import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { RefreshButtonComponent } from './refresh-button.component';

@NgModule({
    imports: [CommonModule, TwcModule, TranslateModule],
    exports: [RefreshButtonComponent],
    declarations: [RefreshButtonComponent],
})
export class RefreshButtonModule {}
